// Vendors
import $ from 'jquery';

$(function () {
  $('[data-carousel="image-slider"]').each(function () {
    const $carousel = $(this);
    const $section = $carousel.closest('.image-slider-section');
    const $slides = $carousel.find('.image-slider__slide');
    const total = $slides.length;
    let current = 0;
    let isAnimating = false;
    const speed = 500;
    const slideWidth = 700;
    const slideGap = 20;
    const step = slideWidth + slideGap;
    const realTotal = total / 2; // since we doubled in PHP

    function positionSlides(animate) {
      const containerWidth = $section.outerWidth();
      const centerX = (containerWidth - slideWidth) / 2;

      $slides.each(function () {
        const $slide = $(this);
        const index = parseInt($slide.attr('data-index'));

        let offset = index - current;
        const half = Math.floor(total / 2);
        if (offset > half) offset -= total;
        if (offset < -half) offset += total;

        const x = centerX + offset * step;
        const isCenter = offset === 0;
        const isVisible = Math.abs(offset) <= 2; // show center + 2 on each side

        $slide.css({
          transform: `translate3d(${x}px, 0, 0) scale(${isCenter ? 1 : 0.72})`,
          transition: animate ? `transform ${speed}ms ease` : 'none'
        });

        $slide.toggleClass('is-center', isCenter);
        $slide.toggleClass('is-visible', isVisible && !isCenter);
      });
    }

    function goTo(direction) {
      if (isAnimating) return;
      isAnimating = true;

      const next = (((current + direction) % total) + total) % total;

      // Silently reposition the entering slide before animating
      const enterIndex =
        (((next + (direction > 0 ? 2 : -2)) % total) + total) % total;

      $slides.each(function () {
        const $slide = $(this);
        const index = parseInt($slide.attr('data-index'));
        if (index === enterIndex) {
          const containerWidth = $section.outerWidth();
          const centerX = (containerWidth - slideWidth) / 2;
          let offset = index - next;
          const half = Math.floor(total / 2);
          if (offset > half) offset -= total;
          if (offset < -half) offset += total;
          const x = centerX + offset * step;

          $slide.css({
            transform: `translate3d(${x}px, 0, 0) scale(0.72)`,
            transition: 'none'
          });
          $slide[0].offsetHeight; // force reflow
        }
      });

      current = next;
      positionSlides(true);

      setTimeout(() => {
        isAnimating = false;
      }, speed);
    }

    $section.find('[data-dir="next"]').on('click', function () {
      goTo(1);
    });

    $section.find('[data-dir="prev"]').on('click', function () {
      goTo(-1);
    });

    positionSlides(false);

    $(window).on('resize', function () {
      positionSlides(false);
    });
  });
});
